module.exports = __webpack_public_path__ + "static/media/hall-AE.9fa1bbc3.svg";